import script from "./MySearchView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySearchView.vue?vue&type=script&setup=true&lang=ts"

import "./MySearchView.vue?vue&type=style&index=0&id=2ed9d168&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ed9d168"]])

export default __exports__